/*  MUI  */
import { Box, Chip } from '@mui/material';

/* Shared */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { HMS } from './HMS';

const RankTooltip = ({ ranking, usage }) => {
    const { t } = useTranslation();

    if (!ranking) {
        return t('Common.tbd_ranking');
    }

    return (
        <>
            <HMS
                seconds={usage}
                includeDays
                includeText
                sx={{ fontSize: FontSizes[0] }}
            />
            {t('Common.usage_over_90')}
        </>
    );
};

export const Rank = (props) => {
    const { usage, ranking } = props;

    return (
        <DarkTooltip
            arrow
            placement="right"
            title={<RankTooltip ranking={ranking} usage={usage} />}
        >
            <Box>
                <Chip
                    label={usage ? ranking : '-'}
                    size="small"
                    variant="rank"
                />
            </Box>
        </DarkTooltip>
    );
};
